import { render, staticRenderFns } from "./EquivalenceAssociationsList.vue?vue&type=template&id=62e76810"
import script from "./EquivalenceAssociationsList.vue?vue&type=script&lang=js"
export * from "./EquivalenceAssociationsList.vue?vue&type=script&lang=js"
import style0 from "./EquivalenceAssociationsList.vue?vue&type=style&index=0&id=62e76810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports